import { UserActionType } from "../features/users/NewUsers";

interface ConfirmationPopupProps {
  isOpen: boolean;
  actionType: UserActionType | "";
  onConfirm: () => void;
  onCancel: () => void;
}

function ConfirmationPopup({
  isOpen,
  actionType,
  onConfirm,
  onCancel,
}: ConfirmationPopupProps) {
  return isOpen ? (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30 z-10">
      <div className="bg-white rounded-lg p-5 max-w-xl w-full shadow-md">
        <h3 className="text-lg font-semibold text-gray-800 mb-3">
          {actionType === "Activate"
            ? "Activate User"
            : actionType === "Deactivate"
            ? "Deactivate User"
            : "Delete User"}
        </h3>
        <p className="text-sm text-gray-600 mb-4">
          {actionType === "Delete"
            ? "Are you sure you want to delete this user? This action cannot be undone."
            : `Are you sure you want to ${actionType === "Activate" ? "Activate" : actionType === "Deactivate" ? "Deactivate" : "Delete"} this user?`}
        </p>
        <div className="flex justify-end gap-3">
          <button
            className="px-4 h-[40px] bg-gray-200 text-gray-800 rounded-md text-sm"
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            className={`px-4 h-[40px] text-white rounded-md text-sm ${
              actionType === "Delete" ? "bg-red-600" : "bg-blue-600"
            }`}
            onClick={onConfirm}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  ) : null;
}

export default ConfirmationPopup;
